(() => {
  if (window.wahaStoriesCarouselReady) return;
  window.wahaStoriesCarouselReady = true;
  const sections = new Map();
  function initialize(root = document) {
    root.querySelectorAll('[data-waha-testimonials]').forEach(section => {
      if (sections.has(section)) return;
      const track = section.querySelector('[data-story-track]');
      if (!track) return;
      const prev = section.querySelector('[data-story-prev]');
      const next = section.querySelector('[data-story-next]');
      const navigation = section.querySelector('[data-story-navigation]');
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (navigation) navigation.hidden = max <= 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      const move = direction => {
        const card = track.querySelector('.wa-testimonials__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      track.addEventListener('scroll', sync, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); track.scrollTo({left:event.key === 'Home' ? 0 : track.scrollWidth,behavior:'instant'}); }
      });
      section.querySelectorAll('video').forEach(video => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'wa-testimonials__play';
        button.setAttribute('aria-label', section.dataset.playLabel);
        button.innerHTML = '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3v18l15-9Z"/></svg></span>';
        video.controls = false;
        video.parentElement.append(button);
        button.addEventListener('click', async () => {
          video.controls = true; button.hidden = true;
          try { await video.play(); video.focus(); }
          catch { video.controls = false; button.hidden = false; button.focus(); }
        });
        video.addEventListener('play', () => { button.hidden = true; video.controls = true; });
        video.addEventListener('ended', () => { video.controls = false; button.hidden = false; });
      });
      const observer = new ResizeObserver(sync); observer.observe(track); sections.set(section,observer); sync();
    });
  }
  document.addEventListener('play', (event) => {
    const playing = event.target;
    if (!(playing instanceof HTMLVideoElement) || !playing.closest('[data-waha-testimonials]')) return;
    document.querySelectorAll('[data-waha-testimonials] video').forEach((video) => {
      if (video !== playing && !video.paused) video.pause();
    });
  }, true);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section,observer] of sections) if(event.target.contains(section)){observer.disconnect();sections.delete(section);}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
})();
